module.exports = __webpack_public_path__ + "files/laurent.89c3515461132f6d5a88f9b32afc3aae.pdf";